import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store/store';
import { configureAmplify } from './services/config/amplify';
import './assets/styles/global.css';
import App from './layouts/App/App';

// Google Maps Platform Extended Component Library - Load globally
import '@googlemaps/extended-component-library/api_loader.js';

// Configure Amplify before rendering the app
// This ensures Amplify is configured before any components or hooks try to use it
configureAmplify();

// Initialize Google Maps API globally after DOM is ready
if (typeof window !== 'undefined') {
  const initializeGoogleMaps = () => {
    const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    if (googleMapsApiKey && !document.querySelector('gmpx-api-loader')) {
      const apiLoader = document.createElement('gmpx-api-loader');
      apiLoader.setAttribute('key', googleMapsApiKey);
      apiLoader.setAttribute('solution-channel', 'GMP_devsite_samples_v3_rgmautocomplete');
      apiLoader.setAttribute('libraries', 'marker,places');
      apiLoader.style.display = 'none'; // Hide it, we just need it to load the API
      document.body.appendChild(apiLoader);
    }
  };

  if (document.body) {
    initializeGoogleMaps();
  } else {
    document.addEventListener('DOMContentLoaded', initializeGoogleMaps);
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
); 